import { _ as pt } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as x } from "./index-8b07dec9.js";
import { useRef as mt, useState as lt } from "react";
import o, { css as a } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as nt } from "./getMetrics-953aa4f8.js";
import "./carousel.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./index-5d0f31c6.js";
import { jsxs as h, jsx as T } from "react/jsx-runtime";
import { InputState as st, HelperText as dt } from "./helperText.js";
import { Label as ut } from "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { useAccessibilityProps as xt } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as ct } from "./uniqueId.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./combineRefs-c9ad2c39.js";
import "./useMediaQuery.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./iconButton.js";
import "./button.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./string-html-forced-a746405b.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var ht = ["onChange", "maxCharacters", "defaultValue", "role", "disabled", "placeholder", "value", "textareaRef", "textSize", "isRequired", "className", "isIncremental", "accessibilityOptions", "labelProp", "infoProp", "trailingText", "helperTextProp", "inputState"], Tt = "TextArea", vt = /* @__PURE__ */ o.div.withConfig({
  displayName: "textArea__TextAreaWrapper",
  componentId: "sc-1ayhta0-0"
})(["&.TextArea-wrapper{", ";}"], function(r) {
  var t = r.theme.components.textArea;
  return a(t.TextAreaWrapper);
}), At = /* @__PURE__ */ o(ut).withConfig({
  displayName: "textArea__TextareaLabel",
  componentId: "sc-1ayhta0-1"
})(["&.TextArea__label{", ";}"], function(r) {
  var t = r.theme.components.textArea;
  return a(t.Label);
}), _t = /* @__PURE__ */ o.textarea.withConfig({
  displayName: "textArea__StyledTextArea",
  componentId: "sc-1ayhta0-2"
})(["&.TextArea{", ";}"], function(r) {
  var t = r.theme.components.textArea;
  return a(t.TextArea);
}), Pt = /* @__PURE__ */ o.div.withConfig({
  displayName: "textArea__Footer",
  componentId: "sc-1ayhta0-3"
})(["&.TextArea__footer{", ";}"], function(r) {
  var t = r.theme.components.textArea;
  return a(t.Footer);
}), bt = /* @__PURE__ */ o.span.withConfig({
  displayName: "textArea__CharLimit",
  componentId: "sc-1ayhta0-4"
})(["&.TextArea__char-limit{", ";}"], function(r) {
  var t = r.theme.components.textArea;
  return a(t.CharLimit);
}), jr = function(t) {
  var p, m, v, A, _, P, b, f, g, y, l, I, S, C, N = t.onChange, n = t.maxCharacters, O = t.defaultValue, j = t.role, M = j === void 0 ? "textbox" : j, i = t.disabled, B = t.placeholder, s = t.value, X = t.textareaRef, R = t.textSize, k = R === void 0 ? "medium" : R, L = t.isRequired, c = L === void 0 ? !1 : L, G = t.className, q = t.isIncremental, J = q === void 0 ? !1 : q, w = t.accessibilityOptions, K = w === void 0 ? {} : w, Q = t.labelProp, U = t.infoProp, Y = t.trailingText, F = t.helperTextProp, Z = t.inputState, $ = pt(t, ht), tt = nt({
    label: "TextArea"
  }), et = mt(ct(Tt)), d = $.id || et.current, z = d + "_message_id", D = d + "_label_id", W = Z || st.NONE, e = F;
  e = Object.assign({}, F, {
    inputState: W
  });
  var u = {
    defaultId: ((p = e) == null || (p = p.defaultProp) == null ? void 0 : p.id) || "default_" + z,
    secondaryId: ((m = e) == null || (m = m.secondaryProp) == null ? void 0 : m.id) || "secondary_" + z
  }, rt = xt("input", Object.assign({
    ariaDisabled: i,
    ariaInvalid: ((v = e) == null ? void 0 : v.inputState) === "caution" || ((A = e) == null ? void 0 : A.inputState) === "error",
    ariaRequired: c,
    ariaLabelledBy: D + " " + u.defaultId + " " + u.secondaryId
  }, K)), H = lt(s || O || ""), it = H[0], ot = H[1], V = (s ?? it).length, at = function(E) {
    ot(E.target.value), N == null || N(E);
  };
  return /* @__PURE__ */ h(vt, Object.assign({
    className: x(["TextArea-wrapper", G])
  }, tt, {
    children: [/* @__PURE__ */ T(At, {
      className: x(["TextArea__label", {
        "TextArea__label--disabled": i
      }]),
      labelProp: Object.assign({
        showRequiredIndicator: c,
        id: D,
        htmlFor: d
      }, Q),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Popup Header"
      }, U),
      trailingText: Y
    }), /* @__PURE__ */ T(_t, Object.assign({
      disabled: i,
      value: s,
      placeholder: B,
      defaultValue: O,
      ref: X,
      role: M,
      maxLength: n,
      onChange: at,
      "aria-required": c,
      "aria-invalid": ((_ = e) == null ? void 0 : _.inputState) === "caution" || ((P = e) == null ? void 0 : P.inputState) === "error" || void 0
    }, $, {
      id: d
    }, rt, {
      className: x(["TextArea", "TextArea--" + k, {
        "TextArea--disabled": i,
        "TextArea--invalid": !i && ((b = e) == null ? void 0 : b.inputState) === "error",
        "TextArea--caution": !i && ((f = e) == null ? void 0 : f.inputState) === "caution",
        "TextArea--success": !i && ((g = e) == null ? void 0 : g.inputState) === "success"
      }])
    })), /* @__PURE__ */ h(Pt, {
      className: "TextArea__footer",
      children: [/* @__PURE__ */ T(dt, {
        inputState: W,
        secondaryProp: Object.assign({
          id: u.secondaryId
        }, (y = e) == null ? void 0 : y.secondaryProp),
        defaultProp: Object.assign({
          id: u.defaultId,
          helperText: ((l = e) == null || (l = l.defaultProp) == null ? void 0 : l.helperText) || ""
        }, (I = e) == null ? void 0 : I.defaultProp)
      }), n !== void 0 && /* @__PURE__ */ h(bt, {
        className: x(["TextArea__char-limit", {
          "TextArea__char-limit--invalid": ((S = e) == null ? void 0 : S.inputState) === "error" || ((C = e) == null ? void 0 : C.inputState) === "caution"
        }]),
        children: [J ? V : n - V, "/", n]
      })]
    })]
  }));
};
export {
  jr as TextArea
};
